import { current } from "@reduxjs/toolkit";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { formatDiffDates, getCurrentDate, removeKeys } from "../../../Utilitie";
import CementLoading from "./CementLoading";
import Loading from "../../../Extra/Loading";
import CrudPage from "../../Dynamic insertion/pages/DynamicCrud/CrudPage";
import DynamicTable from "./SimpleDynamicTable";
import SimpleDynamicTable from "./SimpleDynamicTable";
import RakeLoading from "./RakeLoading";

const keysToRemove = [
  "action",
  "cmdt_code_rake",
  "cnsg",
  "cnsr",
  "demand_expected_long_date",
  "distance",
  "dstn_division",
  "dstn_zone",
  "indent_unit_kms",
  "manual_repeated_date",
  "manual_repeated_time",
  "order_date",
  "order_time",
  "prty_class",
  "quota",
  "report_date",
  "restriction_by_name",
  "restriction_remark",
  "stacking",
  "via",
];
const sampleData = [
  {
    id: 13,
    indent_hdr_id: 12,
    commodity: "CEMT",
    destination: "ELNK, FISG",
    fcn_date: "2026-06-17T00:00:00.000Z",
    fcn_no: 22,
    fcn_time: "01:40:00",
    siding: "JQSG",
    wagon_type: "BCN",
    wagons: 42,
    arr_date: null,
    arr_time: null,
    bpc: null,
    embedded_supply: "1",
    exp_ready: null,
    last_ire: null,
    loading_wagons: null,
    placed_date: null,
    placed_time: null,
    ready_date: null,
    ready_time: null,
    remarks: null,
    rl_dp: null,
    siding_date: null,
    siding_time: null,
    valid: null,
  },
  {
    indent_hdr_id: 101,
    commodity: "CEMT",
    destination: "ELNK, FISG",
    fcn_date: "2026-06-17T00:00:00.000Z",
    fcn_no: 212,
    fcn_time: "01:40:00",
    siding: "RCPB",
    wagon_type: "BCN",
    wagons: 42,
    arr_date: "2025-05-12",
    arr_time: "10:10",
    bpc: "dzf a adsa -a das ",
    embedded_supply: "121",
    exp_ready: "2025-05-10",
    indent_hdr_id: 9,
    last_ire: "12",
    loading_wagons: "12",
    placed_date: null,
    placed_time: null,
    ready_date: "2025-04-12",
    ready_time: "15:12",
    remarks: null,
    rl_dp: null,
    siding_date: null,
    siding_time: null,
    valid: null,
  },
];

const ClsLoadingMaster = () => {
  const [loading, setLoading] = useState(false);
  const [indentCount, setIndentCount] = useState({ cemt: 0, other: 0 });
  const [reFetch, setReFetch] = useState(false);
  const [prevLoadingData, setPrevLoadingData] = useState([]);
  const [LoadingData, setLoadingData] = useState(null);
  const [date, setDate] = useState(getCurrentDate());
  const urlPrefix = process.env.REACT_APP_URL_PREFIX;
  const isItToday = formatDiffDates(getCurrentDate(), date);

  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to the top of the page
  }, []);

  const FetchData = async () => {
    setLoading(true);
    setLoadingData([]);
    try {
      if (isItToday === 0) {
        const response =
          await axios.get(`${urlPrefix}getMultipleTableData?hdr_table=t_indent_hdr&dtl_table=t_indent_dtls&hdr_pk=id&dtl_fk=ind_id&action=accept
          `);
        const response2 = await axios.get(`${urlPrefix}pendingLoading`);
        // console.log(response2);
        const tempData = response2.data.data.map((o) => {
          return { ...o, fcn_date: o.order_date, fcn_time: o.order_time };
        });

        const dataAfterFilterKeys = removeKeys(tempData, keysToRemove);
        const uniqID = [
          ...new Set(
            dataAfterFilterKeys.map((p) => {
              return p.indent_hdr_id;
            }),
          ),
        ];

        setPrevLoadingData(dataAfterFilterKeys);
        if (response?.data?.data) {
          setLoadingData(
            response.data.data.filter((f) => !uniqID.includes(f.hdr_data.id)),
            // response.data.data,
          );
        }
      } else {
        const response = await axios.get(
          `${urlPrefix}pendingLoading?from_date=${date}&to_date=${date}`,
        );
        if (response?.data?.data) {
          const tempData = response.data.data.map((o) => {
            return { ...o, fcn_date: o.order_date, fcn_time: o.order_time };
          });
          // console.log(response.data.data);
          setPrevLoadingData(tempData);
        }
      }
      setLoading(false);
    } catch (err) {
      setLoading(false);

      console.error(err);
    }
  };
  useEffect(() => {
    FetchData();
  }, [date, reFetch]);
  return (
    <div style={{ minHeight: "90vh" }} className="text-center newUi- ">
      {loading && <Loading />}

      <div>
        <div className="row ">
          <div className=" d-flex flex-column">
            <div className="border">
              <SimpleDynamicTable />
            </div>
          </div>
        </div>
      </div>
      <div>
        <div className="row bg-dark text-white newUiBody ">
          <div className="d-flex justify-content-center aline-items-center">
            <h6 className="p-1 ">Insert Data in CLS loading</h6>{" "}
            <div className="">
              <input
                type="date"
                className="form-control"
                max={getCurrentDate()}
                onChange={(e) => {
                  setDate(e.target.value);
                }}
                value={date}
                //   onClick={FetchData}
              />
            </div>
          </div>
        </div>
        <div className="row ">
          <h6 className="newUiBody bg-dark text-white">
            F/C LOADING JBP DIVN{" "}
            <b style={{ fontSize: "12px", color: "rgb(177, 177, 177)" }}>
              Loading Found -{indentCount.cemt}
            </b>
          </h6>
          <div>
            <CementLoading
              setIndentCount={setIndentCount}
              selectedDate={date}
              data={LoadingData?.filter(
                (f) => f?.hdr_data?.commodity === "CEMT",
              )}
              prevLoadingData={prevLoadingData.filter(
                (f) => f.commodity === "CEMT",
              )}
              setReFetch={setReFetch}
            />
          </div>
        </div>{" "}
        <div className="row">
          <h6 className="newUiBody bg-dark text-white">
            RAKE LOADING ( OTHER THAN CEMENT ){" "}
            <b style={{ fontSize: "12px", color: "rgb(177, 177, 177)" }}>
              Loading Found -{indentCount.other}
            </b>
          </h6>
          <div>
            <RakeLoading
              setIndentCount={setIndentCount}
              selectedDate={date}
              data={LoadingData?.filter(
                (f) => f?.hdr_data?.commodity !== "CEMT",
              )}
              prevLoadingData={prevLoadingData.filter(
                (f) => f.commodity !== "CEMT",
              )}
              setReFetch={setReFetch}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
export default ClsLoadingMaster;
